import React from 'react';
import { FadeIn } from './FadeIn';
export function Hero() {
  const coverUrl = 'https://cdn.magicpatterns.com/uploads/bHceqCZJEouS1QMiTHAc1e/ChatGPT_Image_4_jun_2026,_10_48_02_p.m..png';
  return <section className="pt-32 pb-16 md:pt-40 md:pb-24 bg-brand-cream overflow-hidden" data-id="element-74">
      <div className="max-w-[61rem] mx-auto px-6" data-id="element-75">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-8" data-id="element-76">
          {/* Left Side (60%) */}
          <div className="w-full md:w-[60%] flex flex-col items-start" data-id="element-77">
            <FadeIn delay={0.1} data-id="element-78">
              <div className="inline-flex items-center gap-2 bg-brand-sage bg-opacity-20 text-brand-forest px-4 py-1.5 rounded-full text-sm font-medium mb-6" data-id="element-79">
                <span data-id="element-80">🧠</span> Protocolo basado en ciencia
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-81">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-brand-charcoal leading-tight mb-6" data-id="element-82">
                ¿Tu mente no para,
                <br data-id="element-83" />
                tu cuerpo no descansa
                <br data-id="element-84" />
                y sigues adelante
                <br data-id="element-85" />
                aunque estés vacío/a?
              </h1>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-86">
              <p className="text-lg text-brand-gray mb-8 leading-relaxed max-w-xl" data-id="element-87">
                No es debilidad. No es tu culpa. Es tu sistema nervioso pidiendo
                ayuda.
                <strong className="font-semibold text-brand-charcoal block mt-2" data-id="element-88">
                  Desintoxica tu Mente en 21 Días
                </strong>
                es el protocolo natural respaldado por ciencia para eliminar la
                ansiedad, la niebla mental y el agotamiento emocional — sin
                pastillas, sin terapias costosas y sin sacrificios imposibles.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} className="w-full sm:w-auto" data-id="element-89">
              <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} className="w-full sm:w-auto bg-brand-terracotta text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-opacity-90 hover:scale-105 transition-all duration-300 shadow-lg mb-8" data-id="element-90">
                QUIERO DESINTOXICAR MI MENTE →
              </button>
            </FadeIn>

            <FadeIn delay={0.5} data-id="element-91">
              <div className="flex flex-wrap gap-4 text-sm font-medium text-brand-charcoal" data-id="element-92">
                <div className="flex items-center gap-1.5" data-id="element-93">
                  <span data-id="element-94">🧠</span> Respaldado por ciencia
                </div>
                <div className="flex items-center gap-1.5" data-id="element-95">
                  <span data-id="element-96">📥</span> Descarga inmediata
                </div>
                <div className="flex items-center gap-1.5" data-id="element-97">
                  <span data-id="element-98">⭐</span> Protocolo de 21 días
                </div>
              </div>
            </FadeIn>
          </div>

          {/* Right Side (40%) */}
          <div className="w-full md:w-[40%] relative" data-id="element-99">
            <FadeIn delay={0.3} direction="left" data-id="element-100">
              <div className="relative w-full max-w-md mx-auto aspect-[3/5]" data-id="element-101">
                <div className="absolute inset-0 bg-brand-sage opacity-20 rounded-3xl transform translate-x-4 translate-y-4" data-id="element-102"></div>
                <img src={coverUrl} alt="Desintoxica tu Mente en 21 Días E-book Cover" className="relative z-10 w-full h-full object-cover rounded-2xl shadow-2xl" data-id="element-103" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}